import { useState } from "react";
import { Outlet } from "react-router-dom";
import Pool from "./Userpool";
import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import { useNavigate } from "react-router-dom";
import AWS from "aws-sdk";

function App() {
  const [S3, setS3] = useState(null);

  const bucket = process.env.REACT_APP_S3_BUCKET;
  const region = process.env.REACT_APP_REGION;
  const identityPoolID = process.env.REACT_APP_IDENTITY_POOL_ID;
  const logins = process.env.REACT_APP_LOGINS;
  const apiVersion = process.env.REACT_APP_API_VERSION;

  var repositories = [];
  var companies = [];
  var position = "";
  const navigate = useNavigate();
  //Function authenticates user asyncronously using Amazon cognito service
  //It returns a promise to either authenticate or reject in case of failure.
  //It checks if the user belongs to the users pool and verifies their details

  const authenticate = async (Username, Password) => {
    return await new Promise((resolve, reject) => {
      const user = new CognitoUser({ Username, Pool });
      const authDetails = new AuthenticationDetails({ Username, Password });

      user.authenticateUser(authDetails, {
        onSuccess: function (result) {
          resolve(result);
        },

        onFailure: (err) => {
          reject(err);
        },
      });
    });
  };

  async function getS3Internal() {
    return await new Promise((resolve, reject) => {
      if(S3) {
        resolve(S3);
        return;
      }
      else {
        getUserCredentials().then(() => {
          let newS3 = new AWS.S3({
            apiVersion: apiVersion,
            params: { Bucket: bucket }
          });
          setS3(newS3);
          resolve(newS3);
        }).catch(error => reject(error));
      }
    })
  }

  const getUserCredentials = async () => {
    const user = Pool.getCurrentUser();
    if(!user) throw new Error("No Current User");
    user.getSession((err, session) => {
      if(err) throw err;

      let idToken = session.idToken.jwtToken;
      AWS.config.region = region;
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: identityPoolID,
        Logins: { [logins]: idToken },
      });
      AWS.config.credentials.get((err) => {
        if (err) throw err;
      });
    })
  }

  //Repositories' getter
  const getRepo = () => {
    return repositories;
  };

  //Companies' getter
  const getComp = () => {
    return companies;
  };

  //Function that returns the user's session information.
  //It gets the user from the pool, and if the user has a session, gets the user's data

  const getSession = async () => {
    return await new Promise((resolve, reject) => {
      const user = Pool.getCurrentUser();
      if (user) {
        user.getSession((err, session) => {
          if (err) {
            reject();
          } else {
            resolve(session);
            user.getUserData(function (err, userData) {
              if (err) {
                alert(err.message || JSON.stringify(err));
                return;
              }
            });
          }
        });
      } else {
        reject();
      }
    });
  };

  //Function that retrieves a list of companies' data from Amazon S3 bucket.
  const getCompanies = async () => {
    return [];  //This is a hack since hecorep should never use this
    return await new Promise((resolve, reject) => {
      try {
        const user = Pool.getCurrentUser();
        if (user) {
          user.getSession((err, session) => {
            if (err) {
              reject();
            } else {
              user.getUserData(function (err, userData) {
                if (err) {
                  alert(err.message || JSON.stringify(err));
                  return;
                }
                var idToken = session.idToken.jwtToken;
                AWS.config.region = region;
                AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                  IdentityPoolId: identityPoolID,
                  Logins: {
                    [logins]: idToken,
                  },
                });
                AWS.config.credentials.get(function (err) {
                  if (err) return console.error(err);
                  // else console.log(AWS.config.credentials);

                  var s3 = new AWS.S3({
                    apiVersion: apiVersion,
                    params: { Bucket: bucket },
                  });

                  s3.listObjects(
                    { Delimiter: "", Prefix: "" },
                    function (err, data) {
                      companies = data.Contents;
                      resolve(companies);
                    }
                  );
                });
              });
            }
          });
        } else {
          throw new Error("User not authenticated");
          // reject(new Error("User not authenticated"));
        }
      } catch (error) {
        navigate("/");
      }
    });
  };

  //get user Attributes from Cognito
  const getAttributeValue = (attributes, attributeName) => {
    const attribute = attributes.find(
      (attribute) => attribute.Name === attributeName
    );
    return attribute ? attribute.Value : null;
  };

  //Retrieves a list of Repositories that belong to a company.
  const getRepositories = async () => {
    return await new Promise((resolve, reject) => {
      try {
        const user = Pool.getCurrentUser();
        if (user) {
          user.getSession((err, session) => {
            if (err) {
              reject();
            } else {
              user.getUserData(function (err, userData) {
                if (err) {
                  alert(err.message || JSON.stringify(err));
                  return;
                }
                if (
                  getAttributeValue(
                    userData.UserAttributes,
                    "custom:position"
                  ) !== "3"
                ) {
                  localStorage.setItem(
                    "company",
                    getAttributeValue(userData.UserAttributes, "custom:company")
                  );
                }
                var idToken = session.idToken.jwtToken;

                AWS.config.region = region;
                AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                  IdentityPoolId: identityPoolID,
                  Logins: {
                    [logins]: idToken,
                  },
                });
                AWS.config.credentials.get(function (err) {
                  if (err) return console.error(err);
                  // else console.log(AWS.config.credentials);

                  var s3 = new AWS.S3({
                    apiVersion: apiVersion,
                    params: { Bucket: bucket },
                  });

                  s3.listObjects(
                    {
                      Delimiter: "",
                      Prefix:
                        localStorage.getItem("company") + "/Repositories/",
                    },
                    function (err, data) {
                      repositories = data.Contents;
                      resolve(repositories);
                    }
                  );
                });
              });
            }
          });
        } else {
          throw new Error("User not authenticated");
          //reject(new Error("User not authenticated"));
        }
      } catch (error) {
        navigate("/");
      }
    });
  };

  //gets the user details from our pool of users
  const getUserDetails = async () => {
    return await new Promise((resolve, reject) => {
      const user = Pool.getCurrentUser();
      if (user) {
        user.getSession((err, session) => {
          if (err) {
            reject();
          } else {
            user.getUserData(function (err, userData) {
              if (err) {
                alert(err.message || JSON.stringify(err));
                return;
              }
              resolve(userData);
            });
          }
        });
      }
    });
  };

  return (
    <div>
      <main>
        <Outlet
          context={{
            authenticate: authenticate,
            getSession: getSession,
            getRepositories: getRepositories,
            repositories: repositories,
            getRepo: getRepo,
            getUserDetails: getUserDetails,
            position: position,
            companies: companies,
            S3: S3,
            getS3: getS3Internal,
            getCompanies: getCompanies,
            getComp: getComp,
          }}
        />
      </main>
    </div>
  );
}

export default App;
